export default {"src":"/_next/static/media/techLogo1.dfc611c4.svg","height":50,"width":158,"blurWidth":0,"blurHeight":0};